import {
  DatagridConfigurable,
  TextField,
  DateField,
  FunctionField,
  useListContext
} from 'react-admin';
import { useRowStyle } from '../../../../hooks/useRowStyle';
import { TotalRows } from '../../../helperComponents/TotalRows';
import { StatusChip } from './components/StatusChip';
import { truncate } from '../../../../helpers/adsActionsHelpers';
import { BRIDGE_STATUS_COLORS } from '../../../../helpers/googleAdsBridgesConstants';
import { INGEST_RUN_ERROR_PREVIEW_LENGTH } from '../../../../helpers/adsIngestRunsConstants';
import {
  formatRows,
  isRowsShort,
  formatDuration,
  formatWindow,
  formatPage
} from '../../../../helpers/adsIngestRunsHelpers';

export const AdsIngestRunsDataGrid = () => {
  const rowClassName = useRowStyle();
  const { total } = useListContext();

  return (
    <>
      <TotalRows total={total} />
      <DatagridConfigurable
        rowClick="show"
        className={`${rowClassName} datagrid-content`}
        bulkActionButtons={false}
      >
        <TextField source="id" label="ID" />
        <DateField source="received_at" label="Received" showTime />
        <FunctionField
          source="account_name"
          label="Account"
          sortable={false}
          render={(record) => <span title={record.customer_id}>{record.account_name}</span>}
        />
        <FunctionField
          source="job_name"
          label="Job"
          sortable={false}
          render={(record) => `${record.job_name} (${record.job_type})`}
        />
        <FunctionField
          source="display_status"
          label="Status"
          render={(record) => <StatusChip status={record.display_status} />}
        />
        <FunctionField
          source="rows_written"
          label="Rows (received / written)"
          render={(record) => (
            <span style={isRowsShort(record) ? { color: BRIDGE_STATUS_COLORS.RED } : undefined}>
              {formatRows(record)}
            </span>
          )}
        />
        <FunctionField
          source="duration_ms"
          label="Duration"
          render={(record) => formatDuration(record.duration_ms)}
        />
        <FunctionField
          source="date_from"
          label="Window"
          sortable={false}
          render={(record) => formatWindow(record.date_from, record.date_to)}
        />
        <FunctionField
          source="page"
          label="Page"
          sortable={false}
          render={(record) => formatPage(record)}
        />
        <FunctionField
          source="error"
          label="Error"
          sortable={false}
          render={(record) => (
            <span title={record.error}>
              {truncate(record.error || '', INGEST_RUN_ERROR_PREVIEW_LENGTH)}
            </span>
          )}
        />
        <TextField source="script_version" label="Script Version" sortable={false} />
      </DatagridConfigurable>
    </>
  );
};
